
angular.module('bmsApp.crm.customer').factory('ContactSvc', [
	'$q',
	'$rootScope',
	'$modal',
	'$ngBootbox',
	'notify',
	'CRUDSvc',
	'CONTACT_API', function (
		$q,
		$rootScope,
		$modal,
		$ngBootbox,
		notify,
		CRUDSvc,
		CONTACT_API) {

		var self = {
			create: function (contact) {
				return CRUDSvc.post(CONTACT_API.CREATE, contact);
			},
			update: function (contact) {
				return CRUDSvc.post(CONTACT_API.UPDATE + contact.id, contact);
			},
			setPrimary: function (contact) {
				return CRUDSvc.get(CONTACT_API.SET_PRIMARY + contact.id);
			},
			byCustomer: function (customerId, primary, params) {
				var newParams = angular.extend({}, params, {
					filter: {
						customer: customerId,
						primary: primary
					}
				});
				return CRUDSvc.get(CONTACT_API.INDEX, newParams);
			},
			customerOptions: function (customerId) {
				return CRUDSvc.get(CONTACT_API.CUSTOMER_OPTIONS, {
					customerId: customerId
				});
			},
			primaryOptions: function () {
				return CRUDSvc.get(CONTACT_API.PRIMARY_OPTIONS);
			},
			showSaveModal: function (contact) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/crm/customer/templates/ContactSaveModal.html',
					controller: 'ContactModalFormCtrl',
					size: 'lg',
					scope: $rootScope,
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						contact: function () {
							return angular.copy(contact);
						}
					}
				});

				modalInstance.result.then(function (result) {
					if (result.success === true) {
						var message;
						switch (result.action) {
							case 'create':
								message = 'Contact created successfully';
								break;
							case 'update':
								message = 'Contact updated successfully';
								break;
							default:
								message = 'Success';
								break;
						}
						notify({
							message: message
						});
					}
					else {
						notify({
							mesage: result.error,
							classes: 'error'
						});
					}
				}, function () {
					// closed
				});

				return modalInstance.result;
			}
		};
		return self;

}]).constant('CONTACT_API', {
	INDEX: 'api/contact/index',
	CREATE: 'api/contact/create',
	UPDATE: 'api/contact/update/',
	SET_PRIMARY: 'api/contact/set-primary/',
	CUSTOMER_OPTIONS: 'api/contact/customer-options',
	PRIMARY_OPTIONS: 'api/contact/primary-options'
});
